export default {
  baseline: "Grundlinie",
  contract_list: "Vertragsliste",
  success: "Erfolgreich",
  training: {
    code: "Code",
    hours: "Stundenanzahl",
    hours_learning: "Unterrichtsstunden",
    public: "Vorgesehene Zielgruppe",
    comment: "Kommentar",
    registrants_number: "Anzahl der Angemeldeten",
    contact: {
      detail: {
        title: ({ named }) => `Details des Kontakts ${named("name")}`,
      },
    },
  },
  employee: ({ plural }) => plural(["Mitarbeiter/in", "Mitarbeiter"]),
};
